exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".J9Y1oNF3ZpoR5LC3M2PHm{text-decoration:inherit;color:var(--black)}html[dir] .J9Y1oNF3ZpoR5LC3M2PHm{border-radius:2px;padding:0 1px;background-color:var(--neutralLighter)}html[dir] .J9Y1oNF3ZpoR5LC3M2PHm:hover{background-color:var(--neutralLight)}", ""]);
// Exports
exports.locals = {
	"mentionsCompose": "J9Y1oNF3ZpoR5LC3M2PHm"
};